import React, { Component } from 'react';
import RecolhimentoPage from './recolhimento.page';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../pages/laudo/etapas/material/material.action';
import * as commonActions from '@common/common.action';
import RecebimentoMaterialApi from '../../../pages/laudo/etapas/material/material.api';
import WebapiCommon from '../util/webapi.common';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import IntlMessage from '../../../helpers/intlMessage';

class RecolhimentoContainer extends Component {
  constructor() {
    super();
    this.state = {
      setores: [],
      setor: undefined,
      usuarios: [],
      usuarioRecebido: undefined,
      etapas: [],
      nomeEtapa: undefined,
      imprimirEtiquetaControle: false,
      idLaudoLocalizacao: undefined,
      entreguePaciente: false
    };
  }

  render() {
    return (
      <RecolhimentoPage
        entreguePaciente={this.state.entreguePaciente}
        setores={this.state.setores}
        setor={this.state.setor}
        usuarios={this.state.usuarios}
        usuarioRecebido={this.state.usuarioRecebido}
        etapas={this.state.etapas}
        nomeEtapa={this.state.nomeEtapa}
        confirma={this.confirma.bind(this)}
        atualizarState={this.atualizarState.bind(this)}
      />
    );
  }

  componentDidMount() {
    this.props.actions.showFadeCarregando(true);
    Promise.all([
      WebapiCommon.obterLocalProcedencia(),
      WebapiCommon.obterUsuarios(),
      WebapiCommon.obterProcessos(),
    ]).then((array) => {
      const usuarioLogado = getUsuarioLocalStorage();
      this.props.actions.showFadeCarregando(false);
      this.setState({
        imprimirEtiquetaControle: this.props.imprimirEtiquetaControle,
        setores: array[0],
        usuarios: array[1],
        usuarioRecebido: array[1].find(
          (user) => user.value === usuarioLogado.usuarioId
        ),
        etapas: array[2],
      });
    });
  }

  atualizarState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  changeCheckEntregue(val){
    this.setState({ entreguePaciente: val.target.checked })
  }
  

  confirma(e) {
    e.preventDefault();

    let msg =  <IntlMessage id = "dashboards.sample.fillAllFormFields"/> ;
    const tamanho = msg.length * 10 + 'px';
    if (
      !this.state.setor ||
      !this.state.usuarioRecebido ||
      !this.state['nomeEtapa']
    ) {
      return this.props.commonActions.showAlerta('alerta', msg, 3500, tamanho);
    }

    const { laudo } = this.props.detalhes;
    const request = {
      laudo: laudo,
      localOrigem: this.state.setor.value,
      usuariorecebido: this.state.usuarioRecebido.value,
      processo: this.state.nomeEtapa.value,
      entreguePaciente: this.state.entreguePaciente
    };
    RecebimentoMaterialApi.registrarRecolhimentoLaudos(request).then((res) => {
      this.props.actions.imprimiEtiquetaAgora(
        this.state.imprimirEtiquetaControle
      );
      if (typeof this.props.confirmaCallBack === 'function') {
        this.props.confirmaCallBack();
      }
      if(res.sucesso){
        //verificar, quando pesquisa direta pela URL não finaliza 
        //this.props.history.goBack();
      }
    });
  }
}

const mapStateToProps = (state) => {
  return {
    detalhes: state.recebimentoMaterial.detalhes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecolhimentoContainer);



// WEBPACK FOOTER //
// ./src/app/common/recolhimento/recolhimento.container.js